<div class="bp-modal">
	<bp-modal-header>
		<a right (click)="close()" (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
	</bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-body-section pt-10">
			<bp-icon class="info-icon" icon="info" size="32" theme="regular"></bp-icon>
			<h2 class="bp-modal-title">{{ "cash_plus_tooltip_current_rate_title" | translate }}</h2>
			<div class="bp-modal-content">{{ "cash_plus_tooltip_current_rate_first_part" | translate }}</div>
			<div class="bp-modal-content">{{ "cash_plus_tooltip_current_rate_second_part" | translate }}</div>
		</div>
	</div>
</div>
